import { getDefaultDropdownLabelValue, isNotEmpty } from '@helpers'
import { GETObjectDataParamsEnriched, ObjectFieldDTO } from '@types'

import { getResolvedOptionId } from './getResolvedOptionId'

export const createObjectPickerOption = (
  item: GETObjectDataParamsEnriched,
  objLinkField: ObjectFieldDTO | undefined,
  objectValue: string,
  targetIdPath?: string,
  id?: string,
  label?: string
) => {
  const labelValue = label ?? getDefaultDropdownLabelValue(item, objectValue)
  const resolvedOptionId = id ?? getResolvedOptionId(item, objLinkField, targetIdPath)

  return {
    ...item,
    id: resolvedOptionId,
    label:
      (isNotEmpty(labelValue) && typeof labelValue !== 'object') ||
      (labelValue && typeof labelValue === 'object' && Object.keys(labelValue).length)
        ? `${labelValue}`
        : '',
    internalId: item['internal_id'] || '',
  }
}
